import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import {
  Table,
  Button,
  Space,
  Modal,
  Select,
  message,
  Typography,
  Input,
} from "antd";
import GreivanceTable from "../components/GreivanceTable";
const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

function BoothGreivanceList() {
  const [constituencyList, setconstituencyList] = useState([]);
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assemblyList, setassemblyList] = useState([]);
  const [assemblyId, setassemblyId] = useState("");
  const [constituencyId, setconstituencyId] = useState("");
  const [panchayatList, setpanchayatList] = useState([]);
  const [boothList, setboothList] = useState([]);
  const [panchayatId, setpanchayatId] = useState("");
  const [boothId, setboothId] = useState("");
  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setconstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnConstituencySelect = async (value) => {
    setconstituencyId(value);
    setassemblyId("");
    setpanchayatId("");
    setboothId("");
    setassemblyList([]);
    setboothList([]);
    setpanchayatList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) {
        setassemblyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  //   const OnAssemblySelect = async (value) => {
  //     setassemblyId(value);
  //     try {
  //       const res = await dataService.getAssemblyGreivance(value);
  //       if (res.code === 200) {
  //         setGrievances(res.data);
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   };

  const OnAssemblySelect = async (value) => {
    setassemblyId(value);
    setpanchayatId("");
    setboothId("");
    setboothList([]);
    setpanchayatList([]);
    try {
      const res = await dataService.getPanchayatFromAssembly({
        assembly: value,
      });
      if (res.code === 200) setpanchayatList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = async (value) => {
    setpanchayatId(value);
    setboothId("");
    setboothList([]);
    try {
      const res = await dataService.GetBooth({ panchayat: value });
      if (res.code === 200) setboothList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnBoothSelect = async (value) => {
    setboothId(value);

    try {
      const res = await dataService.getAssemblyGreivance(value);
      if (res.code === 200) {
        setGrievances(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getGrievanceList = async (value) => {
    try {
      const res = await dataService.getAssemblyGreivance(value);
      if (res.code === 200) {
        setGrievances(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
  }, []);

  const getNewGrievanceList = () => {
    getGrievanceList(assemblyId);
  };

  return (
    <div>
      <Select
        value={constituencyId}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const children = option?.children;
          return String(children).toLowerCase().includes(input.toLowerCase());
        }}
        placeholder="Select Constituency"
        style={{
          width: 200,
          marginRight: 20,
          border: "1px solid grey",
          borderRadius: 5,
        }}
        onChange={OnConstituencySelect}
      >
        <Option key={827272} value="" disabled>
          Select Parliament
        </Option>
        {constituencyList.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.constituencyName}
          </Option>
        ))}
      </Select>
      <Select
        value={assemblyId}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const children = option?.children;
          return String(children).toLowerCase().includes(input.toLowerCase());
        }}
        placeholder="Select Assembly"
        style={{
          width: 200,
          marginRight: 20,
          border: "1px solid grey",
          borderRadius: 5,
        }}
        onChange={OnAssemblySelect}
      >
        <Option key={827272} value="" disabled>
          Select Assembly
        </Option>
        {assemblyList.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.assemblyName}
          </Option>
        ))}
      </Select>
      <Select
        value={panchayatId}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const children = option?.children;
          return String(children).toLowerCase().includes(input.toLowerCase());
        }}
        placeholder="Select Panchayat"
        style={{
          width: 200,
          marginRight: 20,
          border: "1px solid grey",
          borderRadius: 5,
        }}
        onChange={OnPanchayatSelect}
      >
        <Option key={827272} value="" disabled>
          Select Panchayat
        </Option>
        {panchayatList.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.panchayatName}
          </Option>
        ))}
      </Select>

      <Select
        value={boothId}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const children = option?.children;
          return String(children).toLowerCase().includes(input.toLowerCase());
        }}
        placeholder="Select Booth"
        style={{
          width: 200,
          marginRight: 20,
          border: "1px solid grey",
          borderRadius: 5,
        }}
        onChange={OnBoothSelect}
      >
        <Option key={827272} value="" disabled>
          Select Booth
        </Option>
        {boothList.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.boothNumber}
          </Option>
        ))}
      </Select>
      <div>
        <GreivanceTable
          grievances={grievances}
          getNewGrievanceList={getNewGrievanceList}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default BoothGreivanceList;
